import React from 'react'
import styled from 'styled-components'
import AnswerItemBox from './AnswerItem'
import { Answers } from './Answers'
import size from 'lodash/size'

const AnswersListContainer = styled.ul<{ hasAnswerButton?: boolean, row: number }>`
  padding: 4px;
  width: calc(240px * 2 + 8px * 3);
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  box-sizing: border-box;
  justify-content: flex-end;
  align-content: center;
  height: 100%;
  max-height: ${(p) => `calc((64px + 8px) * ${p.row} + 8px)`};
  ${ (p) => !p.hasAnswerButton ? 'justify-content: flex-start;' : '' }
  @media (max-width: 504px) {
    width: 100%;
  }
  @media (min-width: 896px) {
    width: calc(400px * 2 + 8px * 3);
    max-height: ${(p) => `calc((144px + 8px) * ${p.row} + 8px)`};
  }
`

const AnswerList: React.FC<Answers> = (props) => {
  const isRadio = props.type === 1 //Radio
  const isCheckbox = props.type === 2 // Checkbox
  const answerValue = props.value
  const hasAnswerButton = !isRadio || isRadio && !!props.hasAnswerButton
  const isAnswerValue = !!size(answerValue)
  const isExclusive = answerValue.some((v) => {
    const itemValue = props.items.find(j => v === j.value)
    return (v === itemValue?.value) && itemValue.exclusive
  })
  const row = props.row

  return (
    <AnswersListContainer {...{ hasAnswerButton, row }}>
      {props.items.map((item) => {
        const selected = answerValue.some((v) => v === item.value)

        const disabled = (isExclusive && !item.exclusive) || 
          (!isExclusive && answerValue.length > 0 && item.exclusive)

        return (
          <AnswerItemBox 
            {...{
              text: item.text,
              value: item.value,
              order: item.order || 0,
              fixOrder: item.fixOrder || false,
              exclusive: item.exclusive || false,
              selected: selected,
              disabled,
              row,
              onClick: (value) => {
                if(isCheckbox) {
                  props.onClick(
                    answerValue.some((v) => v === value) ?
                      answerValue.filter((v) => v !== value) :
                      answerValue.concat(value)
                  )
                } else {
                  props.onClick(answerValue.some((v) => v === value) ? [] :[value])
                }
              },
              key: item.value,
              submit: !hasAnswerButton ? props.submit : undefined,
              hasCheckboxIcon: isCheckbox,
            }}
          />
        )
      })}
      {
        hasAnswerButton && (
          <AnswerItemBox {...{
            isAnswer: true,
            text: props.benefitAppealPattern === '1' ? '回答してCMをスキップ' : '回答',
            value: '',
            row,
            onClick: props.submit,
            disabled: !isAnswerValue
          }} />
        )
      }

    </AnswersListContainer>
  )
}

export default AnswerList
